import { CustomerID } from "./Customer";
import { User, UserID } from "./User";

export type CustomerNoteID = number;

export type CustomerNoteAttachmentID = number;

export interface CustomerNote {
  created_on: string;
  updated_on: string;
  id: CustomerNoteID; // Identifier of the Customer Note
  note: string; // Customer Note
  visible_on_wo: boolean; // Note is visible on WO details page
  visible_to_mechanic: boolean; // Note is visible to Mechanic
  customer_id: CustomerID; // Identifier of the Customer
  dms_nr: string | null; // Identifier from the Dealer Management System
  created_by_id: UserID; // Identifier of the User who created the note
  updated_by_id: UserID | null; // Identifier of the User who updated the note
  attachments?: CustomerNoteAttachment[]; // List of attachments of the customer note
  created_by?: User; // User who created the note
  updated_by?: User; // User who updated the note
}

export interface CustomerNoteAttachment {
  created_on: string;
  id: CustomerNoteAttachmentID; // Identifier of the Customer Note Attachment
  url: string; // URL of the Attachment
  type: string; // Type of the Attachment
  name: string; // Name of the Attachment
  customer_note_id: CustomerNoteID; // Identifier of the Customer Note
  created_by_id: UserID; // Identifier of the User who created the attachment
  username?: string; // Name of the user who created this attachment
}
